export enum UserTitle {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Dr = 'Dr',
  Prof = 'Prof',
}
